import { useEffect, useState } from "react";
import { api, apiError, fmtDate } from "./api";
import { Card, PageHead, Empty } from "./widgets";
import { toast } from "sonner";

const ActivityLog = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div data-testid="activity-log">
      <PageHead title="Activity Log" sub="Every administrative action, recorded." />
      {!items ? (
        <p className="text-sm text-[#171717]/50">Loading…</p>
      ) : items.length === 0 ? (
        <Empty>No activity recorded yet.</Empty>
      ) : (
        <Card className="p-0">
          <div className="divide-y divide-[#171717]/6">
            {items.map((a) => (
              <div key={a.id} className="flex flex-col gap-0.5 px-4 py-3.5 sm:flex-row sm:flex-wrap sm:items-baseline sm:gap-x-4 sm:px-5" data-testid={`audit-${a.id}`}>
                <span className="shrink-0 text-[0.65rem] text-[#171717]/45 sm:w-36">{fmtDate(a.ts)}</span>
                <span className="text-[0.7rem] font-medium uppercase tracking-[0.12em] text-[#8a6f3e]">{a.actor}</span>
                <span className="text-sm text-[#171717]/80">{a.action}</span>
                {a.detail && <span className="text-xs text-[#171717]/50">{a.detail}</span>}
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
};

export default ActivityLog;
